import { render } from "./AppsPage.vue?vue&type=template&id=3104f219&scoped=true"
import script from "./AppsPage.vue?vue&type=script&lang=js"
export * from "./AppsPage.vue?vue&type=script&lang=js"

import "./AppsPage.vue?vue&type=style&index=0&id=3104f219&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3104f219"]])

export default __exports__